<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      hostname: require('./variables.js')
    }
  }
}
</script>

<style>
  // Import Simple Line Icons Set
  $simple-line-font-path: "~simple-line-icons/fonts/";
  @import "~simple-line-icons/css/simple-line-icons.css";
</style>
<style lang="scss">
  // Import Main styles for this application
  @import "./scss/style";
  @import "./scss/tooltip";
</style>




// WEBPACK FOOTER //
// src/App.vue?6144f530